import React from 'react'
import { Image, ImageStyle, View } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme } from '@ui-kitten/components'
import { useNavigation } from '@react-navigation/native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Feature, TouchableSection, useFeatureFlag } from '@src/components'
import { useIsDarkMode } from '@src/config/theme'
import { uiFlagsSelector } from '@src/selectors/uiFlags'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { Analytics, CustomEventTypes } from '@config'
import { labsImage } from '@assets/images'
import { UiStateNames } from '@src/types'

export const LabPanelsBanner = () => {
  const styles = useStyleSheet(themedStyles)
  const isDarkMode = useIsDarkMode()
  const uiFlags = useSelector(uiFlagsSelector)
  const navigation = useNavigation()
  const theme = useTheme()
  const dispatch = useDispatch()
  const fullscriptLabsEnabled = useFeatureFlag(Feature.FullscriptLabs)
  const notificationInboxEnabled = useFeatureFlag(Feature.NotificationInbox)
  const showBanner =
    fullscriptLabsEnabled && !notificationInboxEnabled && uiFlags.showFullscriptLabsBanner

  useLazyScreenPreload('LabPanelsScreen', { shouldPreload: showBanner })

  if (!showBanner) {
    return null
  }

  const onPress = () => {
    dispatch({
      type: 'app/upsertUiState',
      payload: {
        name: UiStateNames.FullscriptLabsBannerClicked,
        value: true,
      },
    })
    dispatch({
      type: 'uiFlags/updateUiFlags',
      payload: { showFullscriptLabsBanner: false },
    })
    Analytics.track(CustomEventTypes.FullscriptLabsBannerClicked)
    navigation.navigate('LabPanelsScreen')
  }

  const textColor = isDarkMode ? theme['theme.tooltip.textPrimary'] : theme['theme.text.primary']
  const backgroundColor = isDarkMode
    ? theme['theme.marketing.yellow']
    : theme['theme.marketing.lightYellow']
  const rightArrowColor = isDarkMode ? theme['theme.solid.black'] : undefined

  return (
    <TouchableSection
      title="Unlock your metabolic health"
      subtitle="Order lab tests and review results with your nutritionist."
      onPress={onPress}
      style={[styles.content, { backgroundColor }]}
      subtitleStyle={{ color: textColor }}
      labelStyle={{ color: textColor }}
      accessoryLeft={
        <View style={styles.imageContainer}>
          <Image style={styles.image as ImageStyle} source={labsImage.imageSource} />
        </View>
      }
      showRightArrow
      rightArrowColor={rightArrowColor}
    />
  )
}

const themedStyles = StyleService.create({
  content: {
    borderRadius: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 16,
  },
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 4,
    marginRight: 16,
    height: 56,
    width: 56,
  },
  image: {
    height: 56,
    width: 56,
  },
})
